export default "__VITE_PUBLIC_ASSET__9917ffdc__"